const LoginWrapper = ({ children }) => (
    <div className="relative flex max-lg:h-screen overflow-hidden login-page">
        {/* Logo in top-left corner */}
        <div className="absolute top-8 left-8 z-10">
            <img 
                src="/nasu-logo-white.png" 
                alt="Nasu Capital" 
                className="h-8 w-auto"
            />
        </div>
        
        <div className="flex justify-center items-center grow">
            <div className="w-full max-w-80">
                {children}
            </div>
        </div>
        <div className="relative w-[55%] h-svh max-2xl:w-[60%] max-lg:hidden login-video-container">
            <div className="absolute top-1/2 left-20 -translate-y-1/2 w-[56rem] h-[56rem] overflow-hidden rounded-full max-4xl:w-[59rem] max-4xl:h-[59rem] login-circle">
                <div className="absolute -top-[11%] -left-[62%] -right-[50%] login-video-mask">
                    <video
                        className="w-full"
                        src="/videos/video-5.webm"
                        autoPlay
                        loop
                        muted
                        playsInline
                    />
                </div>
                <div className="absolute top-[17.5rem] -left-[6.25rem] w-[24.75rem] h-[24.75rem] bg-[#7ae2cf]/20 rounded-full blur-[6.75rem]"></div>
                <div className="absolute inset-0 rounded-full shadow-[0.875rem_1.0625rem_1.25rem_0_rgba(255,255,255,0.25)_inset] bg-black/[0.01] max-md:shadow-[0.5rem_0.625rem_0.75rem_0_rgba(255,255,255,0.25)_inset]"></div>
            </div>
            <div className="absolute top-1/2 left-64 translate-y-1/2 z-[2] w-[24.75rem] h-[24.75rem] bg-[#7ae2cf]/20 rounded-full blur-[6.75rem]"></div>
        </div>
    </div>
);

export default LoginWrapper;
